export { setAccessToken, setTokenProvider, clearTokenProvider } from "./AxiosTokenManager";

import { getPayrollAgenticAPI as getCoreApiClient } from "../generated/core-api";
import { getOrgDocumentIngestAPI as getIngestApiClient } from "../generated/ingest-api";

import * as CoreApi from "../generated/core-api";
import * as IngestApi from "../generated/ingest-api";

export { CoreApi, IngestApi };

export const api = getCoreApiClient();
export const ingestApi = getIngestApiClient();
